import { render, staticRenderFns } from "./Chevron.vue?vue&type=template&id=ff36fb08&scoped=true&"
import script from "./Chevron.vue?vue&type=script&lang=js&"
export * from "./Chevron.vue?vue&type=script&lang=js&"
import style0 from "./Chevron.vue?vue&type=style&index=0&id=ff36fb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff36fb08",
  null
  
)

export default component.exports